module.exports = __webpack_public_path__ + "static/media/mx.434d6364.svg";